import { MatPaginatorIntl } from '@angular/material/paginator';

const lang = localStorage.getItem('language');

export function CustomPaginator() {

  const customPaginatorIntl = new MatPaginatorIntl();

  customPaginatorIntl.itemsPerPageLabel =
    lang === 'ar' ? 'إدخالات في الصفحة:' : 'Entries per page:';

  customPaginatorIntl.nextPageLabel =
    lang === 'ar' ? 'الصفحة التالية' : 'Next page';

  customPaginatorIntl.previousPageLabel =
    lang === 'ar' ? 'الصفحة السابقة' : 'Previous page';

  customPaginatorIntl.firstPageLabel =
    lang === 'ar' ? 'الصفحة الأولى' : 'First page';

  customPaginatorIntl.lastPageLabel =
    lang === 'ar' ? 'الصفحة الأخيرة' : 'Last page';

  customPaginatorIntl.getRangeLabel = RangeLabel;

  return customPaginatorIntl;
}

const RangeLabel = (
  page: number,
  pageSize: number,
  length: number
) => {

  if (length === 0 || pageSize === 0) {
    return `0 ${lang === 'ar' ? 'من' : 'of'} ${length}`;
  }

  length = Math.max(length, 0);

  const startIndex = page * pageSize;

  const endIndex = startIndex < length
    ? Math.min(startIndex + pageSize, length)
    : startIndex + pageSize;

  return `${startIndex + 1} - ${endIndex} ${
    lang === 'ar' ? 'من' : 'of'
  } ${length}`;
};